import { actionTypes } from '../actions/layout';

const initialState = {
    isTopBarVisible: true,
    isNavBarVisible: true,
    navPanelIsVisible: false,
    scrollToTop: false,
    activeSubBar: false,
    version: null,
};

export default (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case actionTypes.TOGGLE_NAV_PANEL:
            return {
                ...state,
                navPanelIsVisible: !state.navPanelIsVisible
            }
        case actionTypes.SET_NAV_PANEL_FLAG:
            return {
                ...state,
                navPanelIsVisible: payload
            }
        case '@@redux-flash/ADD_MESSAGE':
        case 'SCROLL_TO_TOP_ENABLE':
            return {
                ...state,
                scrollToTop: true
            };
        case 'SCROLL_TO_TOP_DISABLE':
            return {
                ...state,
                scrollToTop: false
            };
        case 'SHOW_TOP_BAR':
            return {
                ...state,
                isTopBarVisible: true
            };
        case 'HIDE_TOP_BAR':
            return {
                ...state,
                isTopBarVisible: false
            };
        case 'SHOW_NAV_BAR':
            return {
                ...state,
                isNavBarVisible: true
            };
        case 'HIDE_NAV_BAR':
            return {
                ...state,
                isNavBarVisible: false
            };
        case 'SET_ACTIVE_SUB_BAR':
            return {
                ...state,
                activeSubBar: payload,
            };
        case 'LAYOUT_SET_VERSION':
            return {
                ...state,
                version: payload
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/layout.js